import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { getEquippedSurfaceLabel } from '../../../../Sections/labels';
import { EquippedSurface } from '../../../../Sections/properties';
import asSyncChoiceField from '../../asSyncChoiceField';
import SyncChoiceDiffOptionRows from '../../Base/Input/SyncChoiceDiffOptionRows';
import SyncChoiceIdenticalRow from '../../Base/Input/SyncChoiceIdenticalRow';
import SyncInputGroup from '../../Base/Input/SyncInputGroup';
import { isObjectIdenticalValue } from '../../equals';
import { validateListChoiceComplete } from '../../validation';
import {
    getDiffEquippedSurfaceOptionRows,
    getIdenticalEquippedSurfaceOptionRows
} from './functions';

const EquippedSurfacesSyncChoice = ({ planValue, liveValue, value: currentFormValue, onChange, showIdentical }) => {

    const onSelect = (selectedValue) => {
        const newValue = {
            ...currentFormValue,
            ...selectedValue
        };

        onChange(newValue);
    };

    const renderSurfaceLabel = (valueObject) => {

        if (!valueObject) {
            return '-';
        }

        const valueKey = Object.keys(valueObject)[0];

        // Other
        if (valueKey === EquippedSurface.Other) {

            if (valueObject[valueKey] === false) {
                return '-';
            }

            return `Andere: ${valueObject[valueKey]}`;

        }

        // Not set
        if (valueObject[valueKey] === false) {
            return '-';
        }

        return getEquippedSurfaceLabel(Object.keys(valueObject)[0]);
    };

    const isSelected = (value) => {

        if (!currentFormValue || !value) {
            return false;
        }

        const key = value ? Object.keys(value)[0] : undefined;
        if (!key) {
            return false;
        }

        return currentFormValue[key] === value[key];
    };

    const renderIdenticalRows = () => {
        const identicalOptionRows = getIdenticalEquippedSurfaceOptionRows(planValue, liveValue);
        if (_.isEmpty(identicalOptionRows)) {
            return null;
        }

        return identicalOptionRows.map(optionRow => (
            <SyncChoiceIdenticalRow
                key={optionRow.key}
                leftValue={optionRow.left}
                rightValue={optionRow.right}
                renderValue={renderSurfaceLabel}
                showIdentical={showIdentical}
            />
        ));
    };

    const isIdentical = isObjectIdenticalValue(planValue, liveValue);
    if (isIdentical && !showIdentical) {
        return null;
    }

    return (
        <SyncInputGroup
            label="Eingerüstete Flächen"
        >
            {showIdentical && renderIdenticalRows()}

            <SyncChoiceDiffOptionRows
                planValue={planValue}
                liveValue={liveValue}
                getOptionRows={getDiffEquippedSurfaceOptionRows}
                renderValue={renderSurfaceLabel}
                onSelect={onSelect}
                isSelected={isSelected}
            />
        </SyncInputGroup>
    );
};

EquippedSurfacesSyncChoice.propTypes = {
    name: PropTypes.string,
    planValue: PropTypes.object,
    liveValue: PropTypes.object,
    value: PropTypes.any,
    onChange: PropTypes.func,
    showIdentical: PropTypes.bool
};

EquippedSurfacesSyncChoice.defaultProps = {
    planValue: null,
    liveValue: null,
    value: null,
    onChange: () => false
};

export default asSyncChoiceField(EquippedSurfacesSyncChoice, {
    allowNull: true,
    validate: validateListChoiceComplete()
});
